<template>
  <div>
    <div class="alert alert-success text-center" role="alert">
      <h2>Отчет приемки</h2>
    </div>
    <div class="container">
      <div class="mb-1 mt-1 row">
        <div class="col-sm-5 label-class">
          <Multiselect
            v-model="currentReceiver"
            :options="users"
            :loading="false"
            :internal-search="false"
            valueProp="_id"
            trackBy="fullname"
            label="fullname"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            class="deliverer"
            style="min-height: 3rem"
            noOptionsText="Не найден"
            required
          >
          </Multiselect>
        </div>
      </div>

      <div class="mt-1 row">
        <label class="col-sm-2 col-form-label">Начало</label>
        <div class="col-sm-3 label-class">
          <v-date-picker
            v-model="dateFrom"
            mode="dateTime"
            :popover="{ visibility: 'focus' }"
            is24hr
            utc
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="
                  px-2
                  border
                  rounded
                  focus:outline-none focus:border-blue-300
                "
                :value="inputValue"
                v-on="inputEvents"
                style="
                  width: 100%;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  line-height: 2;
                "
              />
            </template>
          </v-date-picker>
        </div>
      </div>

      <div class="mt-1 row">
        <label class="col-sm-2 col-form-label">Конец</label>
        <div class="col-sm-3 label-class">
          <v-date-picker
            v-model="dateTo"
            mode="dateTime"
            :popover="{ visibility: 'focus' }"
            is24hr
            utc
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="
                  px-2
                  border
                  rounded
                  focus:outline-none focus:border-blue-300
                "
                :value="inputValue"
                v-on="inputEvents"
                style="
                  width: 100%;
                  padding-top: 2px;
                  padding-bottom: 2px;
                  line-height: 2;
                "
              />
            </template>
          </v-date-picker>
        </div>
      </div>

      <div class="mt-1 row">
        <div class="col-sm-5 label-class">
          <button type="button" class="btn btn-primary btn-lg w-100 berry" @click="getReport()">
            СФОРМИРОВАТЬ
          </button>
        </div>
      </div>
      <div class="mt-1 row">
        <div class="col-sm-5 label-class">
          <button type="button" class="btn btn-warning btn-lg w-100 berry" @click="printReport()">
            ПЕЧАТЬ
          </button>
        </div>
      </div>
    </div>

    <div v-if="report.length > 0" class="mt-3">
      <table class="table fs-8" id="report-print">
        <thead>
          <tr>
            <th>Ягода</th>
            <th>Всего, кг</th>
            <th v-if="false">Усушка, кг</th>
            <th v-if="false">Сухой, кг</th>
            <th>Средняя цена, у.е.</th>
            <th>Сумма, у.е.</th>
            <th>На пути в ФБ, кг</th>
            <th>Доставлено в ФБ, кг</th>
            <th>Остаток, кг</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(berry, index) in report" :key="index">
            <td>
              <button
                class="btn btn-light"
                @click="currentBerry = berry"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#berry-${berry.berryId}`"
                aria-expanded="true"
                :aria-controls="`berry-${berry.berryId}`"
              >
                {{ berry.berryLabel }}
              </button>
            </td>
            <td>{{ berry.resultAcceptance.weightSum.total.toFixed(2) }}</td>
            <td v-if="false">{{ berry.resultAcceptance.weightShrink.total.toFixed(2) }}</td>
            <td v-if="false">{{ berry.resultAcceptance.weightDry.total.toFixed(2) }}</td>
            <td>{{ berry.resultAcceptance.priceAvg.toFixed(2) }}</td>
            <td>{{ berry.resultAcceptance.sumTotal.toFixed(2) }}</td>

            <td>{{ berry.resultAcceptance.weightShipmentCreated.toFixed(2) }}</td>
            <td>{{ berry.resultAcceptance.weightShipmentClosed.toFixed(2) }}</td>
            <td>{{ berry.resultAcceptance.weightBalance.toFixed(2) }}</td>
          </tr>
          <tr class="fw-bold">
            <td>ИТОГО</td>
            <td>{{ reportSum.acceptWeightSumTotal.toFixed(2) }}</td>
            <td v-if="false">{{ reportSum.acceptweightShrinkTotal.toFixed(2) }}</td>
            <td v-if="false">{{ reportSum.acceptWeightDryTotal.toFixed(2) }}</td>
            <td>{{ reportSum.priceAvg.toFixed(2) }}</td>
            <td>{{ reportSum.sum.toFixed(2) }}</td>

            <td>{{ reportSum.weightShipmentCreated.toFixed(2) }}</td>
            <td>{{ reportSum.weightShipmentClosed.toFixed(2) }}</td>
            <td>{{ reportSum.weightBalance.toFixed(2) }}</td>
          </tr>

          <tr>
            <td colspan="6">
              <div class="accordion fs-10" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="`#berry-${currentBerry.berryId}`"
                      aria-expanded="true"
                      :aria-controls="`berry-${currentBerry.berryId}`"
                    >
                      Подробно: {{ currentBerry.berryLabel }}
                    </button>
                  </h2>
                  <div
                    :id="`berry-${currentBerry.berryId}`"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div v-if="currentBerry" class="accordion-body">
                      <div
                        v-for="acceptance in currentBerry.resultAcceptance.acceptances"
                        :key="acceptance._id"
                        class="row"
                      >
                        <div class="row">
                          <router-link
                            :to="{
                              name: 'acceptance',
                              params: { id: acceptance._id }
                            }"
                          >
                            Акт приемки №{{ acceptance.prefix }}-{{ acceptance.number }} от
                            {{ new Date(acceptance.date).toLocaleString() }}
                          </router-link>
                        </div>
                        <div class="row">
                          <div class="row row-cols-5">
                            <div class="col text-muted lh-1">
                              <small>Вес всего, кг</small>
                            </div>
                            <div v-if="false" class="col text-muted lh-1">
                              <small>Усушка, кг</small>
                            </div>
                            <div v-if="false" class="col text-muted lh-1">
                              <small>Cухой, кг</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>Цена, у.е.</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>Сумма, у.е.</small>
                            </div>
                          </div>

                          <div class="row row-cols-5">
                            <div class="col text-muted lh-1">
                              <small>{{ acceptance.tableUnit[0].weight.toFixed(2) }}</small>
                            </div>
                            <div v-if="false" class="col text-muted lh-1">
                              <small>{{ acceptance.receiverShrinkTotal.toFixed(2) }}</small>
                            </div>
                            <div v-if="false" class="col text-muted lh-1">
                              <small>{{ acceptance.receiverDryTotal.toFixed(2) }}</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>{{ acceptance.tableUnit[0].price.toFixed(2) }}</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>{{ acceptance.sum.toFixed(2) }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table v-if="false" class="table fs-8">
        <thead>
          <tr>
            <th>Ягода</th>
            <th>Вес сухой, кг</th>
            <th>Средняя цена, у.е.</th>
            <th>Сумма, у.е.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(berry, index) in report" :key="index">
            <td>
              <button
                class="btn btn-light"
                @click="currentBerry = berry"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#berry-${berry.berryId}`"
                aria-expanded="true"
                :aria-controls="`berry-${berry.berryId}`"
              >
                {{ berry.berryLabel }}
              </button>
            </td>
            <td>{{ berry.resultTransfer.weightDry.toFixed(2) }}</td>
            <td>{{ berry.resultTransfer.priceAvg.toFixed(2) }}</td>
            <td>{{ berry.resultTransfer.sum.toFixed(2) }}</td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="accordion fs-10" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="`#berry-${currentBerry.berryId}`"
                      aria-expanded="true"
                      :aria-controls="`berry-${currentBerry.berryId}`"
                    >
                      Подробный расчет: {{ currentBerry.berryLabel }}
                    </button>
                  </h2>
                  <div
                    :id="`berry-${currentBerry.berryId}`"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div v-if="currentBerry" class="accordion-body">
                      <div
                        v-for="transfer in currentBerry.resultTransfer.transfers"
                        :key="transfer._id"
                        class="row"
                      >
                        <div class="row">
                          <router-link
                            :to="{
                              name: 'transfer',
                              params: { id: transfer._id }
                            }"
                          >
                            Акт передачи №{{ transfer.prefix }}-{{ transfer.number }} от
                            {{ new Date(transfer.date).toLocaleString() }}
                          </router-link>
                        </div>
                        <div class="row">
                          <div class="row">
                            <div class="col text-muted lh-1">
                              <small>Вес сухой, кг</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>Цена, у.е.</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>Сумма, у.е.</small>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col text-muted lh-1">
                              <small>{{ transfer.tableUnit[0].weight }}</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>{{ transfer.tableUnit[0].price }}</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>{{
                                transfer.tableUnit[0].weight * transfer.tableUnit[0].price
                              }}</small>
                            </div>
                          </div>

                          <div class="accordion" :id="`accordion-transfer-${transfer._id}`">
                            <div class="accordion-item">
                              <h2 class="accordion-header" :id="`heading-transfer-${transfer._id}`">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  :data-bs-target="`#transfer-${transfer._id}`"
                                  aria-expanded="true"
                                  :aria-controls="`transfer-${transfer._id}`"
                                >
                                  <small>РАСЧЕТ ЦЕНЫ</small>
                                </button>
                              </h2>
                              <div
                                :id="`transfer-${transfer._id}`"
                                class="accordion-collapse collapse"
                                :aria-labelledby="`heading-transfer-${transfer._id}`"
                                :data-bs-parent="`#accordion-transfer-${transfer._id}`"
                              >
                                <div class="accordion-body">
                                  <div class="row row-cols-1 pt-2">
                                    <div
                                      class="row"
                                      v-for="(detail, index) in transfer.details"
                                      :key="index"
                                    >
                                      <div class="row text-muted mt-1">
                                        <router-link
                                          :to="{
                                            name: 'acceptance',
                                            params: { id: detail.acceptanceId }
                                          }"
                                        >
                                          <small>{{ detail.acceptanceLabel }}</small>
                                        </router-link>
                                      </div>
                                      <div class="row row-cols-3">
                                        <div class="col text-muted">
                                          <small>Ставка бонус, у.е.</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>Ставка логистика, у.е.</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>Общая усушка, %</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.rateTotal.bonus }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.rateTotal.logist }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.rateTotal.shrink }}</small>
                                        </div>

                                        <div class="col text-muted mt-2">
                                          <small>Всего</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Закрыто</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Принято</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Вес сухой, кг</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Вес сухой, кг</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Вес сухой, кг</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.weightDry.total }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.weightDry.closed }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.weightDry.accept }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Усушка, кг</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Усушка, кг</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Усушка, кг</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.weightShrink.total }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.weightShrink.closed }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.weightShrink.accept }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма всего, у.е.</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма всего, у.е.</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма всего, у.е.</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumDry.total }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumDry.closed }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumDry.accept }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма усушка, у.е.</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма усушка, у.е.</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма усушка, у.е.</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumShrink.total }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumShrink.closed }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumShrink.accept }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма логистика, у.е.</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма логистика, у.е.</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма логистика, у.е.</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumLogist.total }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumLogist.closed }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumLogist.accept }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма бонус, у.е.</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма бонус, у.е.</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма бонус, у.е.</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumBonus.total }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumBonus.closed }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumBonus.accept }}</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <div class="d-flex justify-content-center">
      <img class="img img-fluid" width="150" src="moroshka.png" alt="" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import { onMounted, ref, computed } from "vue";
import useCommonMixin from "@/components/commonMixin.js";
import { useStore } from "vuex";
import Multiselect from "@vueform/multiselect";

export default {
  name: "ReportMaster",

  components: { Multiselect },

  setup(props) {
    useCommonMixin();
    const store = useStore();
    const { asyncForEach, userProfile } = useCommonMixin();
    const currentReceiver = ref();
    const users = ref([]);
    const dateFrom = ref("");
    const dateTo = ref("");
    const report = ref([]);
    const currentBerry = ref("");

    const init = async () => {
      await store.dispatch("FETCHberry");
      let responseUsers = await store.dispatch("FETCHreceiverUsersForBerryResult");
      users.value = responseUsers.status ? responseUsers.data : [];
      users.value.forEach(user => {
        user.fullname = `${user.receiver.fullname}`;
      });

      let currentUserIndex = users.value.findIndex(item => item._id == userProfile.value._id);
      currentReceiver.value = currentUserIndex >= 0 ? userProfile.value._id : null;
    };

    const getReport = async () => {
      report.value = [];
      let responseReport = await store.dispatch("FETCHreportReceiver", {
        dateFrom: dateFrom.value ? dateFrom.value.toISOString() : new Date(1, 1, 1).toISOString(),
        dateTo: dateTo.value ? dateTo.value.toISOString() : new Date(7777, 1, 1).toISOString(),
        receiverId: currentReceiver.value
      });

      report.value = responseReport.status ? responseReport.data : [];
    };

    // <td>{{ berry.resultAcceptance.weightSum.total.toFixed(2) }}</td>
    // <td>{{ berry.resultAcceptance.weightShrink.total.toFixed(2) }}</td>
    // <td>{{ berry.resultAcceptance.weightDry.total.toFixed(2) }}</td>
    // <td>{{ berry.resultAcceptance.priceAvg.toFixed(2) }}</td>
    // <td>{{ berry.resultAcceptance.sumTotal.toFixed(2) }}</td>

    const reportSum = computed(() => {
      let reportSum = {
        acceptWeightSumTotal: 0,
        acceptweightShrinkTotal: 0,
        acceptWeightDryTotal: 0,
        priceAvg: 0,
        sum: 0,
        weightShipmentCreated: 0,
        weightShipmentAccept: 0,
        weightShipmentClosed: 0,
        weightBalance: 0
      };

      report.value.forEach(berry => {
        reportSum.acceptWeightSumTotal =
          reportSum.acceptWeightSumTotal + berry.resultAcceptance.weightSum.total;
        // reportSum.acceptweightShrinkTotal = reportSum.acceptweightShrinkTotal + berry.resultAcceptance.weightShrink.total
        // reportSum.acceptWeightDryTotal = reportSum.acceptWeightDryTotal + berry.resultAcceptance.weightDry.total

        reportSum.acceptweightShrinkTotal = 0;
        reportSum.acceptWeightDryTotal = 0;

        reportSum.sum = reportSum.sum + berry.resultAcceptance.sumTotal;

        reportSum.weightShipmentCreated += berry.resultAcceptance.weightShipmentCreated;
        reportSum.weightShipmentAccept += berry.resultAcceptance.weightShipmentAccept;
        reportSum.weightShipmentClosed += berry.resultAcceptance.weightShipmentClosed;
        reportSum.weightBalance += berry.resultAcceptance.weightBalance;
      });

      if (reportSum.acceptWeightSumTotal > 0) {
        reportSum.priceAvg = reportSum.sum / reportSum.acceptWeightSumTotal;
      }

      return reportSum;
    });

    const printReport = () => {
      var divToPrint = document.getElementById("report-print");
      divToPrint.setAttribute("border", "1");

      let newWin = window.open("");
      newWin.document.write(divToPrint.outerHTML);
      newWin.print();
      newWin.close();
      divToPrint.setAttribute("border", "0");
    };

    onMounted(init);

    return {
      currentReceiver,
      getReport,
      dateFrom,
      dateTo,
      report,
      reportSum,
      currentBerry,
      users,
      printReport
    };
  }
};
</script>

<style>
.fs-8 {
  font-size: 0.8rem !important;
}

.fs-10 {
  font-size: 1rem !important;
}
</style>
